<footer class="footer">
    <dp-nav-footer></dp-nav-footer>
    <dp-social-network></dp-social-network>
    <dp-links-footer></dp-links-footer>
    <dp-footer-copyright></dp-footer-copyright>
</footer>
